<template>
    <div>
        <!-- 标题-->
        <el-breadcrumb separator="/" class="bread">
            <!--<el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>-->
            <el-breadcrumb-item>活动管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!--创建活动 按钮-->
        <!--@click="getData" icon="search":loading="loading"-->
        <el-button type="primary" @click="toCreate">
            创建活动
        </el-button>
        <!--搜索活动-->
        <div style="margin-top: 10px">
            <el-input v-model="actName" placeholder="活动名称" style="width: 20%"></el-input>
            <el-button type="primary"  @click="findAct()">
                查询
            </el-button>
            <el-button type="primary"  @click="resetAct()" :disabled="isReset">
                重置
            </el-button>
        </div>
        <!-- 表格分页-->
        <div class="block">
            <el-table :data="tableData" border style="width: 100%;">
                <el-table-column prop="act_name" label="活动名称">
                </el-table-column>
                <el-table-column prop="act_status" label="状态">
                    <template scope="scope">
                        <div v-if="getStatus(scope.row)==1">未开始</div>
                        <div v-if="getStatus(scope.row)==2">进行中</div>
                        <div v-if="getStatus(scope.row)==4">已暂停</div>
                        <div v-if="getStatus(scope.row)==3">已结束</div>
                        <div v-if="getStatus(scope.row)==5">编辑中</div>
                    </template>
                </el-table-column>

                <el-table-column prop="update_time" label="创建时间" :formatter="formatter" sortable>
                </el-table-column>
                <el-table-column label="操作" width="350">
                    <template scope="scope">
                        <el-button size="small" type="text"
                                   v-if="getStatus(scope.row)==4"
                        @click="startOrPaseAct(scope.row,1)">
                            开启
                        </el-button>
                        <el-button size="small" type="text"
                                   v-if="getStatus(scope.row)==1
                                   ||getStatus(scope.row)==2"
                        @click="startOrPaseAct(scope.row,0)">
                            暂停
                        </el-button>
                        <el-button size="small" type="text"
                                   v-if="getStatus(scope.row)==1
                                   ||getStatus(scope.row)==4
                                   ||getStatus(scope.row)==5"
                                   @click="goToEditer(scope.row)">
                            编辑
                        </el-button>
                        <!--<el-button size="small" type="text"
                                   v-if="getStatus(scope.row)==1
                                   ||getStatus(scope.row)==2
                                   ||getStatus(scope.row)==3
                                   ||getStatus(scope.row)==4">
                            复制
                        </el-button>
                        <el-button size="small" type="text"
                                   v-if="getStatus(scope.row)==1
                                   ||getStatus(scope.row)==2
                                   ||getStatus(scope.row)==3
                                   ||getStatus(scope.row)==4">
                            链接
                        </el-button>
                        <el-button size="small" type="text"
                                   v-if="getStatus(scope.row)==2
                                   ||getStatus(scope.row)==3
                                   ||getStatus(scope.row)==4">
                            活动效果
                        </el-button>-->
                        <el-button size="small" type="text"
                                   v-if="getStatus(scope.row)==5||
                                   getStatus(scope.row)==3
                                   ||getStatus(scope.row)==4"
                        @click="deleteAct(scope.row)">
                            删除
                        </el-button>
                        <el-button size="small" type="text"
                                   v-if="getStatus(scope.row)==2||
                                   getStatus(scope.row)==3 "
                                   @click="checkAct(scope.row)">
                            查看
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="block">
            <el-pagination
                    @current-change="handleCurrentChange"
                    @size-chahange="handleSizeChange"
                    :current-page="currentpage"
                    :page-count="pagesCount"
                    :page-sizes="pagesizes"
                    :page-size="pagesize"
                    :total="pagesCount"
                    layout=" total, prev, pager, next, jumper"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
    // import action from "../../../store/actions"
    import moment from 'moment'

    export default {
        name: "ActivityManager",
        data() {
            return {
                //页眉设置参数
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pagesizes: [10, 20, 30],//条数列
                pagesize: 10,//行数
                activeNum: 0, //默认起始行数
                endNum: 10,//默认结束行数
                tableData: [], // 分页组件传回的分页后数据
                actName: null,
                loading: false,
                isable: false,
                dialogVisible: false,
                tenantId:'',//租户ID
                isReset:true,
                newCreate:false,//新创建活动的标志
            }
        },
        created() {
            this.tenantId = this.getcookie("storeId");
            this.getData(this.actName);
            this.newCreate=this.$route.query.newCreate;
            // console.log("状态："+this.newCreate)
            if (this.newCreate) {
                this.toCreate()
            }
        },
        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.pagesize = val
                this.activeNum = (val * this.currentpage) - val;
                this.endNum = (val * this.currentpage)
                this.getData(this.actName);
                //数目变更
            },
            handleCurrentChange(val) {
                this.currentpage = val;
                this.activeNum = (this.pagesize * val) - this.pagesize
                this.endNum = (this.pagesize * val)
                this.getData(this.actName);
            },
            /*模糊查询按钮*/
            findAct(){
                this.isReset = false
                this.currentpage = 1//当前页数默认是1
                // this.pagesCount = 0 //总数默认0
                this.pagesize = 10//行数
                this.activeNum = 0 //默认起始行数
                this.getData(this.actName)
            },
            /*重置按钮*/
            resetAct(){
                this.isReset = true
                this.actName = null;
                this.getData(this.actName)
            },
            /*查询数据*/
            getData(name) {
                //数据请求
                this.loading = true
                var params = "";
                if (name == null) {
                    params = "?iDisplayStart="+ this.activeNum + "&iDisplayLength="
                        + this.pagesize+"&tenantId="+this.tenantId
                }else{
                    params = "?iDisplayStart="+ this.activeNum + "&iDisplayLength="
                        + this.pagesize+"&tenantId="+this.tenantId+"&actName="+name
                }
                //异步请求
                // this.$http.get(this.actManagerHost+this.findActListURL + "?iDisplayStart="
                //     + this.activeNum + "&iDisplayLength=" + this.pagesize+"&tenantId="+this.tenantId)
                this.$http.get(this.actManagerHost+this.findActListURL+params)
                    .then(response => {
                        console.log(response.body)
                        if (response.status === 200) {
                            this.pagesCount = response.body.Data.count
                            this.tableData = response.body.Data.actlist
                            this.loading = false;
                            console.log( this.pagesCount);
                        }
                    }, function (response) {
                        this.$message({ showClose: true, message: '网络异常', type: 'error'});
                    })
            },
            /*状态判断*/
            getStatus(row) {
                var startTime = this.timeCycle(row.act_start_date);
                var endTime = this.timeCycle(row.act_end_date);
                var currentTime = new Date().getTime();
                if (row.act_status == 1) {
                    if ((currentTime - startTime) < 0) {
                        /*未开始*/
                        return 1;
                    } else if ((currentTime - endTime) < 0) {
                        /*进行中*/
                        return 2;
                    } else {
                        /*已结束*/
                        return 3;
                    }
                }else if (row.act_status == 0) {
                    /*已暂停*/
                    return 4;
                }else if (row.act_status == -1) {
                    /*编辑中*/
                    return 5;
                }else{
                    return 0;
                }
            },
            /*跳转创建活动*/
            toCreate() {
                this.savecookie("button", "CreateActivity");
                this.$router.push({
                    // path: "CreateActivity",query:{actId:" ",isEditer:false}
                    path: "CreateActivity",
                    query:{actId:" ",btnStatus:"0",act_status:-999}
                });
            },
            /*编辑页面跳转*/
            goToEditer(row){
                console.log("编辑按钮："+row.act_id)
                this.savecookie("button", "CreateActivity");
                this.$router.push({
                    // path: "CreateActivity",query:{actId:row.act_id,isEditer:true}
                    path: "CreateActivity",
                    query:{actId:row.act_id,btnStatus:"1",act_status:row.act_status}
                });
            },
            /*查看活动*/
            checkAct(row){
                this.savecookie("button", "CreateActivity");
                this.$router.push({
                    path: "CreateActivity",
                    query:{actId:row.act_id,btnStatus:"2",act_status:row.act_status}
                });
            },

            /*删除活动*/
            deleteAct(row){
                this.$confirm('你确定要删除这条数据么？删除是不可恢复的', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //数据请求
                    this.loading = true
                    var params = {actId:row.act_id};
                    //异步请求
                    //this.actManagerHost+this.deleteActInfoURL

                    this.$http.post(this.actManagerHost+this.deleteActInfoURL,params)
                        .then(response => {
                            if (response.status === 200) {
                                if (response.body.Code == "200") {
                                    this.$message({showClose: true, message: '删除成功', type: 'success'});
                                    this.getData();
                                }else if (response.body.Code == "400") {
                                    this.$message({
                                        showClose: true,
                                        message: '参数错误',
                                        type: 'error'
                                    });
                                }else if (response.body.Code == "500") {
                                    this.$message({
                                        showClose: true,
                                        message: '网络异常',
                                        type: 'error'
                                    });
                                }
                            }
                        },function(response){
                            this.$message({ showClose: true, message: '网络异常',type: 'error'});
                        })
                })
            },
            /*开启/暂停 活动*/
            startOrPaseAct(row,status){
                //数据请求
                this.loading = true
                var params = {actStatus:status,actId:row.act_id};
                //异步请求
                this.$http.post(this.actManagerHost+this.startOrPaseActURL,params)
                    .then(response => {
                        if (response.status === 200) {
                            if (response.body.Code == "200") {
                                if (status == 0) {
                                    this.$message({showClose: true, message: '暂停成功', type: 'success'});
                                }else if (status == 1) {
                                    this.$message({showClose: true, message: '开启成功', type: 'success'});
                                }
                                this.getData(this.actName);
                            }else if (response.body.Code == "400") {
                                console.log("400")
                                this.$message({ showClose: true, message: '参数错误', type: 'error' });
                            }else if (response.body.Code == "500") {
                                console.log("500")
                                this.$message({ showClose: true, message: '网络异常', type: 'error' });
                            }
                        }
                    },function(response){
                        console.log("fail")
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'
                        });
                    })

            },
            /*日期转换时间戳*/
            timeCycle(time) {
                var date = new Date(time.replace(/-/g, '/'));
                return date.getTime();
            },

            formatter(row, column) {
                var d = new Date(row.update_time);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },

        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ActivityManager.vue?2a29bf0a